import React, { useState } from 'react';
import { XCircleIcon, XIcon } from '@heroicons/react/solid';

type ErrorAlertProps = {
  children: string;
};

function ErrorAlert({ children }: ErrorAlertProps): JSX.Element | null {
  const [dismissed, setDismissed] = useState<boolean>(false);

  if (dismissed) {
    return null;
  }

  return (
    <div className="fixed top-0 inset-x-0 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-2 sm:pt-5">
      <div className="p-4 rounded-md bg-red-50 shadow">
        <div className="flex">
          <div className="flex-shrink-0">
            <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-red-800">{children}</p>
          </div>
          <div className="ml-auto pl-3">
            <div className="-mx-1.5 -my-1.5">
              <button
                type="button"
                onClick={() => setDismissed(true)}
                className="inline-flex bg-red-50 rounded-md p-1.5 text-red-600 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600"
              >
                <span className="sr-only">Dismiss</span>
                <XIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorAlert;
